module.exports = __webpack_public_path__ + "static/media/brokenImage.ab025cf1.png";